// src/features/notes/notesSlice.ts
import { createSlice, nanoid, PayloadAction } from "@reduxjs/toolkit";
import { Note } from "../../types";

const initialState: { notes: Note[] } = {
  notes: [
    {
      id: "1",
      user: "test@gmail.com",
      title: "Welcome note",
      description: "This is a dummy note to get you started.",
    },
    {
      id: "2",
      user: "test@gmail.com",
      title: "Second Note",
      description: "Buy milk and bread",
    },
    {
      id: "3",
      user: "luke.skywalker@resistence.com",
      title: "Welcome note by luke",
      description: "This is a dummy note to get you started.",
    },
    {
      id: "4",
      user: "darth.vader@empire.com",
      title: "Welcome note by vader",
      description: "This is a dummy note to get you started.",
    },
    {
      id: "5",
      user: "yoda@jedicouncil.com",
      title: "Welcome note by yoda",
      description: "This is a dummy note to get you started.",
    },
  ],
};

export const notesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    addNote: {
      reducer(state, action: PayloadAction<Note>) {
        state.notes.push(action.payload);
      },
      prepare(user: string, title: string, description: string) {
        return { payload: { id: nanoid(), user, title, description } };
      },
    },
    // updateNote(
    //   state,
    //   action: PayloadAction<{ id: string; changes: Partial<Note> }>
    // ) {
    //   const { id, changes } = action.payload;
    //   const note = state.notes.find((n) => n.id === id);
    //   if (note) Object.assign(note, changes);
    // },
    deleteNote(state, action: PayloadAction<string>) {
      state.notes = state.notes.filter((n) => n.id !== action.payload);
    },
  },
});

export const { addNote, deleteNote } = notesSlice.actions;
export default notesSlice.reducer;
